import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import { GameAnimations, Utils } from "../..";
export default class Pick {
    constructor(pickContainer, pickFont, pickFromPSD, index) {
        this.isPicked = false;
        this.winAmountToContainerWidthRateo = .8;
        this.index = index;
        this.pickDisplay = pickFromPSD.phaser.display;
        this.pickDimensions = pickFromPSD.dimensions;
        this.pickSpine = this.setPickSpine();
        this.pickText = this.setPickText(pickFont);
        this.pickTextSymbol = this.setPickText(pickFont);
        this.pickText.setOrigin(0.5, 0);
        this.pickTextSymbol.setOrigin(0.5, 1);
        this.touchArea = this.touchAreaFromPSD();
        this.pickContainer = pickContainer;
        this.pickContainer.add(this.pickSpine);
        this.pickContainer.add(this.pickText);
        this.pickContainer.add(this.pickTextSymbol);
        this.pickContainer.add(this.touchArea);
    }
    getPickSpine() {
        return this.pickSpine;
    }
    setPickSpine() {
        const spine = scene.add.spine(this.pickDisplay.x, this.pickDisplay.y, ResourcesDispatcher.SPINES.PickBonus.jsonKey, ResourcesDispatcher.SPINES.PickBonus.atlasKey).setOrigin(0.5);
        spine.animationState.addAnimation(0, 'cocktail_' + (this.index + 1) + '_idle', false);
        return spine;
    }
    enableInteraction(onPick) {
        this.touchArea.input.enabled = true;
        this.touchArea.on('pointerdown', () => {
            if (this.isPicked)
                return;
            this.isPicked = true;
            this.touchArea.input.enabled = false;
            this.pickSpine.animationState.setAnimation(0, 'cocktail_' + (this.index + 1) + '_win', true);
            onPick();
        });
    }
    getPickText() {
        return this.pickText;
    }
    getPickTextSymbol() {
        return this.pickTextSymbol;
    }
    setPickText(pickFont) {
        return scene.add.text(this.pickDisplay.x, this.pickDisplay.y, "", pickFont).setOrigin(0.5);
    }
    setPickValue(rawString) {
        let { symbol, value } = Utils.splitTextValueFromSymbol(rawString);
        if (symbol) {
            this.pickTextSymbol.setText(symbol);
            this.pickText.setText(value);
            this.pickText.setScale(Utils.findOptimalScale(this.pickText.width, this.pickDimensions.width, this.winAmountToContainerWidthRateo));
            /* if (symbol.length > 3) {
            } else {
                this.pickTextSymbol.setText("");
                this.pickText.setText(symbol + "" + value);
            } */
        }
        else {
            this.pickTextSymbol.setText("");
            this.pickText.setText(value);
        }
        return this.pickText;
    }
    getPickContainer() {
        return this.pickContainer;
    }
    getIsPicked() {
        return this.isPicked;
    }
    setIsPicked(isPicked) {
        this.isPicked = isPicked;
    }
    getTouchArea() {
        return this.touchArea;
    }
    setTouchArea(touchArea) {
        this.touchArea = touchArea;
    }
    touchAreaFromPSD() {
        const touchArea = scene.add.graphics();
        // touchArea.lineStyle(10, 0xff0000, 1);
        touchArea.strokeRect(this.pickDisplay.x - this.pickDimensions.width / 2, this.pickDisplay.y - this.pickDimensions.height / 2, this.pickDimensions.width, this.pickDimensions.height);
        touchArea.setInteractive(new Phaser.Geom.Rectangle(this.pickDisplay.x - this.pickDimensions.width / 2, this.pickDisplay.y - this.pickDimensions.height / 2, this.pickDimensions.width, this.pickDimensions.height), Phaser.Geom.Rectangle.Contains);
        touchArea.input.cursor = 'pointer';
        touchArea.input.enabled = false;
        return touchArea;
    }
    animatePickWin(targetValue) {
        const startingValue = 0;
        this.pickContainer.parentContainer.bringToTop(this.pickContainer);
        let onUpdateCallback = (textAmount) => {
            if (textAmount.width > this.pickDimensions.width * this.winAmountToContainerWidthRateo) {
                textAmount.setScale(Utils.findOptimalScale(textAmount.width, this.pickDimensions.width, this.winAmountToContainerWidthRateo));
            }
        };
        return new Promise(resolve => {
            GameAnimations.tweenCounterSplitText(this.pickText, this.pickTextSymbol, startingValue, targetValue, 1000, resolve, onUpdateCallback);
        });
    }
}
